import EventBus from '../EventBus';
import { GameEvents } from '../GameEvents';
import type { DisplayInfo } from '../../types/Components';

export interface ExamineSlice {
  examinedEnemyId: number | null;
  enemyName: string;
  displayInfos: DisplayInfo[];
  expanded: boolean;
}

export default class ExamineHandler {
  private state: any;
  private slice: ExamineSlice;
  private eventBus: EventBus;

  constructor(state: any, slice: ExamineSlice, eventBus: EventBus) {
    this.state = state;
    this.slice = slice;
    this.eventBus = eventBus;

    this.eventBus.on(GameEvents.ENEMY_EXAMINED, (payload: {
      entityId: number;
      enemyName: string;
      displayInfos: DisplayInfo[];
    }) => {
      this.slice.examinedEnemyId = payload.entityId;
      this.slice.enemyName = payload.enemyName;
      this.slice.displayInfos = payload.displayInfos;
      this.slice.expanded = false;
    });

    this.eventBus.on(GameEvents.ENEMY_EXAMINE_DISMISSED, () => {
      this.slice.examinedEnemyId = null;
      this.slice.enemyName = '';
      this.slice.displayInfos = [];
      this.slice.expanded = false;
    });

    this.eventBus.on(GameEvents.ENEMY_STAT_SHEET_TOGGLED, () => {
      this.slice.expanded = !this.slice.expanded;
    });
  }
}
